import { css as r } from "styled-components";
const e = /* @__PURE__ */ r([
  "position:absolute;overflow:hidden;clip:rect(0.1rem,0.1rem,0.1rem,0.1rem);width:0.1rem !important;height:0.1rem !important;padding:0 !important;border:0 !important;"
]);
export {
  e as default
};
